import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import {useSelector} from "react-redux";
import { AppState } from '../../../store/rootReducer';
import IndirectDealerFlowColumn from '../../Shared/IndirectDealerFlowColumn/IndirectDealerFlowColumn';
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import Divider from "@mui/material/Divider";
import CardHeader from "@mui/material/CardHeader";
import {CardContent} from "@mui/material";
import Card from "@mui/material/Card";
import {IApplication} from "../../../Interfaces/Application/IApplication";
import { OverviewQuote } from "./OverviewQuote";
import { IConfiguration, useConfiguration } from "../../../Data/ConfigurationData";
import { userHasPermission } from "../../../utils/utils";
import { permissions } from "../../../utils/constants";
import { PermissionSet } from "@amsanalytics/react-shared-library";

export interface DecisionBoxIndirectDealerViewProps {
  disableQuotes?: boolean;
  updateApplication: (fn: (app: IApplication) => IApplication | void) => void;
  configuration: IConfiguration;
}

export const DecisionBoxIndirectDealerView: React.FC<DecisionBoxIndirectDealerViewProps> = (
  props
) => {
  const currentApp = useSelector((state: AppState) => state.applications.editingApp);
  const organizations = useSelector((state: AppState) => state.applications.lookups.organizations);
  // const dealertrackDealerDecisionData = useSelector((state: AppState) => state.applications.dealertrackDealerDecisionData);
  const { data: configuration } = useConfiguration();
  const [showMoreQuoteFields, setShowMoreQuoteFields] = useState(!configuration?.isFinanceCompany);
  const activeUser = useSelector((state: AppState) => state.applications.loggedInUser?.employee);

  return (
    <Card style={{ marginTop: 8 }}>
      <CardHeader
        avatar={<AssignmentTurnedInIcon fontSize="small" />}
        title="Decision Box"
      />
      <Divider variant="middle" />
      <CardContent>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
                {/*{props.disableQuotes !== true && dealertrackDealerDecisionData && (*/}
                {/*  <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>*/}
                {/*    <IndirectDealerFlowColumn*/}
                {/*      {...props}*/}
                {/*      style={{marginLeft: '10px'}}*/}
                {/*      dealerFlowData={dealertrackDealerDecisionData}*/}
                {/*      dealerName={organizations.find(o => o.id === currentApp?.organizationId)?.name ?? ''}*/}
                {/*      appSource={currentApp?.appSource ?? ''}*/}
                {/*      configuration={props.configuration}  */}
                {/*    />*/}
                {/*  </div>*/}
                {/*)}*/}
            </div>
          </Grid>
          {/* NOTE: This is still used to show Eastons legacy app quotes. Easton is an exception and they are not indirect */}
          {activeUser && userHasPermission(activeUser, permissions.nonUnderwriterViewCalculatedColumn, PermissionSet.R) && currentApp && currentApp.applicationQuotes.length > 0 && (
            <Grid item xs={4}>
              <OverviewQuote
                applicationQuote={currentApp?.applicationQuotes[0]!}
                i={0}
                updateApplication={props.updateApplication!}
                showMoreQuoteFields={false}
                isDealerRetailQuote={false}
              />
            </Grid>
          )}

        </Grid>
      </CardContent>
    </Card>
  );
};
